"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function OwnedLicenseDelete(row) {
  var displayName = (0, _get2["default"])(row, 'metadata.originalAssigneeName');
  var displayRole = (0, _get2["default"])(row, 'metadata.originalAssigneeRole');
  if (displayName && displayRole) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Revoke license from ", displayRole, " ", /*#__PURE__*/_react["default"].createElement("b", null, displayName));
  }
  if (displayName) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Revoke license from ", /*#__PURE__*/_react["default"].createElement("b", null, displayName));
  }
  if (displayRole) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Revoke license from unknown ", displayRole, /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Revoke license from an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
}
var _default = exports["default"] = OwnedLicenseDelete;